import React from "react";
import { useQuery } from "seed/gql";
import { Loading } from "seed/helpers";
import * as indexes from "components/studio/Controller.lib.index";
import * as parser from "components/studio/Controller.lib.parser";
import View from "components/vmisc/flow_preview/MiniBoard.view";


function MiniBoard({ flowId, pageId, focusedNodeId = null }) {

  const queries = [`flow.id=${flowId}`];
  if (pageId) {
    queries.push(`page.id=${pageId}`);
  } else {
    queries.push(`page.isDefault=True`);
  }

  const filterPage = queries.join(" AND ");
  const reqNodes = useQuery(`{
    flowNodes {
      createdAt
      inputValues
      outputValues
      uiSettings
      isEnabled
      rootName
      rootDescription
      action { 
        name
        type
        isEditable
        inputStructure
        outputStructure
        uiSettings
        isAnnotation
        app { 
          name
          uiSettings
        }
      }
      isVerified
      flow { name }
    }
  }`, filterPage);

  const reqEdges = useQuery(`{
    flowEdges {
      type
      createdAt
      sourceName
      targetName
      source { }
      target { }
      flow { name }
    }
  }`, filterPage);

  const reqAnnotations = useQuery(`{
    flowAnnotations {
      createdAt
      inputValues
      uiSettings      
      action { 
        name
        type
        isEditable
        inputStructure
        outputStructure
        uiSettings
        isAnnotation
        app { 
          name
          uiSettings
        }
      }
      flow { name }
    }
  }`, filterPage);

  if (reqNodes.loading || reqEdges.loading || reqAnnotations.loading)
    return <PlaceholderView><Loading /></PlaceholderView>

  if (reqNodes.error || reqEdges.error || reqAnnotations.error)
    return <PlaceholderView></PlaceholderView>

  if (!flowId)
    return <PlaceholderView></PlaceholderView>

  const { flowNodes = [] } = reqNodes.data;
  const { flowEdges = [] } = reqEdges.data;
  const { flowAnnotations = [] } = reqAnnotations.data;

  const tempNodes = parser.parseNodesGraphqlToUi(flowNodes);
  const edges = parser.parseEdgesGraphqlToUi(flowEdges);
  const tempAnnotations = parser.parseAnnotationsGraphqlToUi(flowAnnotations);

  const nodes = tempNodes.map((node) => {
    const newNode = { ...node }
    if (node.remoteId && focusedNodeId && node.remoteId == focusedNodeId) {
      newNode.data.is_selected = true;
    }
    newNode.data.is_preview = true;
    return newNode;
  })

  const annotations = tempAnnotations.map((annotation) => {
    const newAnnotation = { ...annotation }
    newAnnotation.data.is_preview = true;
    return newAnnotation;
  })

  const indexedNodes = indexes.assignIdxNodes(nodes, edges);
  let focusedNode = null;

  if (focusedNodeId) {
    focusedNode = indexedNodes.find(node => node.remoteId == focusedNodeId);
  }

  return (
    <View
      flowId={flowId}
      nodes={indexedNodes}
      edges={edges}
      annotations={annotations}
      focusedNode={focusedNode}
    />
  );
}


const PlaceholderView = ({ children }) => {
  return (
    <div className="bg-white" style={{ width: "100vw", height: "100vh" }}>
      {children}
    </div>
  )
}


export default MiniBoard;